// Vite entrypoint for F2 Portfolio Manager
// This is the main entry point for Vite-bundled assets

// NOTE: CSS is loaded via entrypoints/application.css and vite_stylesheet_tag
// to prevent FOUC during Turbo navigation (CSS must load before content renders)

// Import existing Rails dependencies
import '@hotwired/turbo-rails'

// Canvas coordinator — global singleton for all canvas visualizations
import '../canvas/canvas-coordinator'

// Stimulus setup
import { Application } from "@hotwired/stimulus"

const application = Application.start()
window.Stimulus = application

// Register controllers
import DropdownController from "../controllers/dropdown_controller"
application.register("dropdown", DropdownController)

import AutofocusController from "../controllers/autofocus_controller"
application.register("autofocus", AutofocusController)

// TEMPORARY: Font tester - remove when done
import FontTesterController from "../controllers/font_tester_controller"
application.register("font-tester", FontTesterController)

import PaymentRecordingsController from "../controllers/payment_recordings_controller"
application.register("payment-recordings", PaymentRecordingsController)

import FormTrackerController from "../controllers/form_tracker_controller"
application.register("form-tracker", FormTrackerController)

import ThemeController from "../controllers/theme_controller"
application.register("theme", ThemeController)

import CustomSelectController from "../controllers/custom_select_controller"
application.register("custom-select", CustomSelectController)

export { application }

